'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import capitalize from "../utils/capitalize.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import { getSvgIconUtilityClass } from "./svgIconClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var color = ownerState.color, fontSize = ownerState.fontSize, classes = ownerState.classes;
    var slots = {
        root: [
            'root',
            color !== 'inherit' && "color".concat(capitalize(color)),
            "fontSize".concat(capitalize(fontSize))
        ]
    };
    return composeClasses(slots, getSvgIconUtilityClass, classes);
};
var SvgIconRoot = styled('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles["color".concat(capitalize(ownerState.color))],
            styles["fontSize".concat(capitalize(ownerState.fontSize))]
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    var _transitions_duration, _transitions, _theme_transitions_create, _theme_transitions, _theme_typography_pxToRem, _theme_typography, _theme_typography_pxToRem1, _theme_typography1, _theme_typography_pxToRem2, _theme_typography2, _palette_action, _palette, _palette_action1, _palette1;
    var _theme_vars, _theme_vars1, _theme_vars2, _theme_vars3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: (_theme_transitions = theme.transitions) === null || _theme_transitions === void 0 ? void 0 : (_theme_transitions_create = _theme_transitions.create) === null || _theme_transitions_create === void 0 ? void 0 : _theme_transitions_create.call(_theme_transitions, 'fill', {
            duration: (_transitions = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).transitions) === null || _transitions === void 0 ? void 0 : (_transitions_duration = _transitions.duration) === null || _transitions_duration === void 0 ? void 0 : _transitions_duration.shorter
        }),
        variants: [
            {
                props: function(props) {
                    return !props.hasSvgAsChild;
                },
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_pxToRem = _theme_typography.pxToRem) === null || _theme_typography_pxToRem === void 0 ? void 0 : _theme_typography_pxToRem.call(_theme_typography, 20)) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_pxToRem1 = _theme_typography1.pxToRem) === null || _theme_typography_pxToRem1 === void 0 ? void 0 : _theme_typography_pxToRem1.call(_theme_typography1, 24)) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_pxToRem2 = _theme_typography2.pxToRem) === null || _theme_typography_pxToRem2 === void 0 ? void 0 : _theme_typography_pxToRem2.call(_theme_typography2, 35)) || '2.1875rem'
                }
            }
        ].concat(// TODO v5 deprecate color prop, v6 remove for sx
        _to_consumable_array(Object.entries(((_theme_vars1 = theme.vars) !== null && _theme_vars1 !== void 0 ? _theme_vars1 : theme).palette).filter(function(param) {
            var _param = _sliced_to_array(param, 2), value = _param[1];
            return value && value.main;
        }).map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            var _palette_color, _palette;
            var _theme_vars;
            return {
                props: {
                    color: color
                },
                style: {
                    color: (_palette = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_color = _palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main
                }
            };
        })), [
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (_palette = ((_theme_vars2 = theme.vars) !== null && _theme_vars2 !== void 0 ? _theme_vars2 : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_action = _palette.action) === null || _palette_action === void 0 ? void 0 : _palette_action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (_palette1 = ((_theme_vars3 = theme.vars) !== null && _theme_vars3 !== void 0 ? _theme_vars3 : theme).palette) === null || _palette1 === void 0 ? void 0 : (_palette_action1 = _palette1.action) === null || _palette_action1 === void 0 ? void 0 : _palette_action1.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ])
    };
}));
var SvgIcon = /*#__PURE__*/ React.forwardRef(function SvgIcon(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'inherit' : _props_color, _props_component = props.component, component = _props_component === void 0 ? 'svg' : _props_component, _props_fontSize = props.fontSize, fontSize = _props_fontSize === void 0 ? 'medium' : _props_fontSize, htmlColor = props.htmlColor, _props_inheritViewBox = props.inheritViewBox, inheritViewBox = _props_inheritViewBox === void 0 ? false : _props_inheritViewBox, titleAccess = props.titleAccess, _props_viewBox = props.viewBox, viewBox = _props_viewBox === void 0 ? '0 0 24 24' : _props_viewBox, other = _object_without_properties(props, [
        "children",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "inheritViewBox",
        "titleAccess",
        "viewBox"
    ]);
    var hasSvgAsChild = /*#__PURE__*/ React.isValidElement(children) && children.type === 'svg';
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    var more = {};
    if (!inheritViewBox) {
        more.viewBox = viewBox;
    }
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ _jsxs(SvgIconRoot, _object_spread_props(_object_spread({
        as: component,
        className: clsx(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props), {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ _jsx("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Node passed into the SVG element.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */ color: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'inherit',
            'action',
            'disabled',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        PropTypes.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'inherit',
            'large',
            'medium',
            'small'
        ]),
        PropTypes.string
    ]),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: PropTypes.string,
    /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */ inheritViewBox: PropTypes.bool,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */ shapeRendering: PropTypes.string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: PropTypes.string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */ viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
export default SvgIcon;
